const confimeaDictES = {
  headerPartnership: "Asociación",
  headerHelp: "Ayuda",
  headerBackToConfimea: "Volver al sitio de Confimea",
  heroBadge: "Bienvenido al Business Square de Confimea Imprese",
  heroTitle: "Activa tu acceso digital",
  heroTitleSpan: "en Business Square",
  heroText: "Si tu empresa está asociada a Confimea Imprese, solicita el acceso Manager y comienza inmediatamente a aprovechar los procesos digitales de Business Square.",
  heroButton: "SOLICITAR ACTIVACIÓN MANAGER",
  heroStat1Value: "500+",
  heroStat1Label: "Empresas activas",
  heroStat2Value: "24h",
  heroStat2Label: "Activación rápida",
  heroStat3Value: "98%",
  heroStat3Label: "Satisfacción del cliente",
  benefitsBadge: "BENEFICIOS EXCLUSIVOS",
  benefitsTitle: "¿Por qué activar el perfil Manager en la plataforma Business Square?",
  benefitsSubtitle: "Herramientas diseñadas para digitalizar y hacer crecer tu empresa asociada en la red digital.",
  benefit1Title: "Presencia digital estructurada",
  benefit1Text: "Crea el perfil de tu empresa y gestiona la visibilidad online con herramientas simples y dedicadas.",
  benefit2Title: "CashBack y fidelización",
  benefit2Text: "Integra programas de fidelización para incentivar a los clientes a volver y aumentar las ventas.",
  benefit3Title: "Soporte dedicado Confimea",
  benefit3Text: "Accede a un soporte prioritario dedicado a los miembros de Confimea Imprese para todas las necesidades.",
  benefit4Title: "Analytics e informes",
  benefit4Text: "Monitorea el rendimiento de tu actividad con dashboards intuitivos e informes detallados.",
  benefit5Title: "Red Business Square",
  benefit5Text: "Únete a una red de empresas y accede a oportunidades de negocio y networking.",
  benefit6Title: "Certificación digital",
  benefit6Text: "Obtén badges y certificaciones que acreditan tu pertenencia a la red Confimea.",
  benefitLink: "Descubre más",
  benefitsInfoBannerText: "¿Necesitas más información?",
  benefitsInfoBannerText2: "Contacta con nuestro equipo y te ayudaremos a comenzar.",
  benefitsInfoBannerButton: "Contactar con soporte",
  howItWorksBadge: "PROCESO SIMPLE",
  howItWorksTitle: "¿Cómo funciona la activación del perfil Manager?",
  howItWorksSubtitle: "Tres pasos simples para activar la digitalización de tu empresa asociada.",
  step1Title: "Completa el formulario",
  step1Text: "Ingresa los datos de tu empresa y la información requerida para la verificación.",
  step1Link: "2 minutos",
  step2Title: "Verificación y aprobación",
  step2Text: "Tu perfil será verificado por el equipo para confirmar tu pertenencia.",
  step2Link: "24-48 horas",
  step3Title: "Activación inmediata",
  step3Text: "Recibe el acceso a la plataforma y comienza inmediatamente a gestionar tu actividad.",
  step3Link: "Inmediato",
  ctaBadge: "Comienza hoy mismo",
  ctaTitle: "¿Listo para comenzar?",
  ctaText: "Con unos simples pasos puedes activar el acceso a la plataforma Business Square y comenzar a gestionar tu actividad de forma digital y profesional.",
  ctaButton: "Completa el formulario",
  formBadge: "Registro rápido",
  formTitle: "Solicita el acceso Manager",
  formSubtitle: "Completa el formulario y en 24 horas recibirás la activación de tu cuenta como Manager en la plataforma.",
  formCompanyLabel: "Nombre de la Empresa/Entidad",
  formCompanyPlaceholder: "Ej. Consultorio Médico Rossi",
  formNameLabel: "Nombre y Apellidos",
  formNamePlaceholder: "Mario Rossi",
  formEmailLabel: "Email corporativo",
  formEmailPlaceholder: "nombre@empresa.com",
  formPasswordLabel: "Contraseña",
  formPasswordPlaceholder: "Crea una contraseña segura",
  formPartnerCodeLabel: "Código de Socio",
  formPartnerCodeOptional: "(opcional)",
  formPartnerCodePlaceholder: "Si tienes un código de socio, ingrésalo aquí",
  formAcceptTerms: "Acepto los",
  formTermsLink: "Términos y Condiciones",
  formAnd: "y la",
  formPrivacyLink: "Política de Privacidad",
  formTermsSuffix: "de Extraconomy y Confimea Imprese.",
  formAcceptMarketing: "Consiento en recibir comunicaciones comerciales y actualizaciones sobre los servicios.",
  formSubmit: "Enviar solicitud de activación",
  formCaptcha: "Protegido por reCAPTCHA - Privacidad y Términos de Google",
  partnershipBadge: "Asociación oficial",
  partnershipTitle: "Asociación oficial",
  partnershipSubtitle: "Un canal dedicado exclusivamente a empresas asociadas a Confimea Imprese para acceder a digitalización y funcionalidades activas.",
  partnershipLink1: "Ver todos los beneficios",
  partnershipLink2: "Regístrate ahora",
  faqBadge: "FAQ",
  faqTitle: "Preguntas frecuentes",
  faqSubtitle: "Encuentra respuestas a las preguntas más comunes sobre la asociación y la activación.",
  faq1Question: "¿Quién puede acceder al activar una activación?",
  faq1Answer:
    "Solo las empresas oficialmente asociadas a Confimea Imprese pueden completar este formulario. Durante el proceso de verificación, verificaremos cuidadosamente el código asociado proporcionado para confirmar la pertenencia a la red y garantizar el acceso a los beneficios exclusivos de la asociación.",
  faq2Question: "¿Está incluido el servicio activo/asistencia en el plan Manager?",
  faq2Answer:
    "No. Después de enviar el formulario, nuestro equipo verifica cuidadosamente los datos y la asociación con Confimea Imprese. Posteriormente, nos pondremos en contacto contigo para completar la activación y proporcionarte las credenciales de acceso. El proceso de verificación normalmente toma 24-48 horas laborables, pero trabajamos para ser lo más rápidos posible.",
  faq3Question: "¿Se requiere personal técnico para usar la plataforma?",
  faq3Answer:
    "Absolutamente no. Business Square ha sido diseñada específicamente para gestores de empresas, con una interfaz intuitiva y fácil de usar. No se requiere ninguna experiencia técnica particular. Además, ofrecemos formación inicial completa y soporte dedicado para todos los nuevos Managers, garantizando una incorporación fluida y productiva.",
  faq4Question: "¿Cuáles son los costos asociados al plan Manager?",
  faq4Answer:
    "Para las empresas asociadas a Confimea Imprese, el plan Manager incluye condiciones especiales acordadas en la asociación. Nuestro equipo proporcionará todos los detalles sobre costos y condiciones durante el proceso de activación, junto con una presentación completa de las funcionalidades disponibles.",
  faq5Question: "¿Puedo cancelar el acceso Manager en cualquier momento?",
  faq5Answer:
    "Sí, tienes total libertad para gestionar tu acceso. Puedes solicitar la suspensión o cancelación en cualquier momento contactando con el soporte dedicado. No hay restricciones contractuales rígidas, y nuestro objetivo es siempre garantizar la máxima satisfacción y flexibilidad para los socios.",
  contactTitle: "¿Tienes otras preguntas?",
  contactText: "Nuestro equipo está listo para ayudarte y responder todas tus preguntas en tiempo real.",
  contactButton1: "Contáctanos ahora",
  contactButton2: "Ir a FAQ",
  footerPartnership: "Asociación",
  footerLink1: "Para Empresas Asociadas",
  footerLink2: "Cómo funciona",
  footerLink3: "FAQ",
  footerQuickLinks: "Enlaces rápidos",
  footerLink4: "Sitio Extraconomy",
  footerLink5: "Solicitar acceso",
  footerLink6: "Soporte",
  footerContacts: "Contactos",
  footerCopyright: "Extraconomy Global srl - P.IVA 16948681008 - Todos los derechos reservados",
  email: "Email",
  fullName: "Nombre completo",
  formSuccessBadge: "Registro completado",
  formSuccessTitle: "Verifica tu email",
  formSuccessSubtitle: "Enviamos un link de confirmación a tu email. Haz clic en el link para activar tu cuenta Manager y comenzar a usar la plataforma Business Square.",
  formSuccessMessage: "Enviamos un email de confirmación a:",
  formSuccessNote: "Por favor, revisa tu bandeja de entrada y activa tu cuenta a través del enlace enviado en el email.",
  formSuccessStep1: "Abre el email que te enviamos",
  formSuccessStep2: "Haz clic en el botón de confirmación",
  formSuccessStep3: "Serás redirigido al inicio de sesión de la plataforma",
  formSuccessEmailNotReceived:
    "¿No recibiste el email? Revisa tu carpeta de spam.",
  emailVerified: "¡Email Verificado!",
  completeActivationSubtitle: "Completa la activación enviando la documentación solicitada",
  requiredDocuments: "Documentos Necesarios para la activación completa",
  document1: "Para completar la validación de tu inscripción en Confimea Imprese en Business Square, te solicitaremos estos documentos.",
  document2: "Puedes prepararlos y enviarlos con calma: no es necesario hacerlo inmediatamente.",
  document3: "Descarga el formulario, complétalo y firmanlo. Podrás cargar el formulario y los otros documentos en tu área personal cuando sea más conveniente para ti.",
  downloadTemplateDocument: "DESCARGAR DOCUMENTO PLANTILLA",
  uploadYourDocuments: "Carga tus documentos",
  uploadedFiles: "Archivos cargados",
  ready: "Listo",
  chooseFile: "Elegir archivo",
  dragFilesHereOrClick: "Arrastra los archivos aquí o haz clic para seleccionar",
  fileFormatsHint: "PDF, JPG, PNG (Máx 10MB por archivo)",
  documentsVerificationInfo: "Los documentos serán verificados en un plazo de 24 horas laborables. Recibirás una confirmación por correo electrónico.",
  skipAndGoToLogin: "SALTAR E IR AL LOGIN",
  sendDocumentation: "ENVIAR DOCUMENTACIÓN",
  privacyNote: "Tus documentos serán tratados de forma confidencial según las normativas GDPR.",
  confirmingEmail: "Confirmando email...",
  confirmationMissingParams: "Faltan parámetros de confirmación",
  confirmationError: "Error al confirmar el email",
  fileUploadedSuccessfully: "Archivo cargado con éxito",
  pleaseUploadDocument: "Por favor, carga un documento",
  documentSentSuccessfully: "Documentación enviada con éxito",
  confirmationDocumentDescription: "Documentación de activación Confimea Imprese",
  goToLogin: "Ir al Login",
  removeFile: "Eliminar",
  documentsReceived: "DOCUMENTOS RECIBIDOS",
  documentationSentSuccessfully: "¡Documentación enviada con éxito!",
  documentationSentSuccessfullySubtitle: "Gracias por enviar tus documentos. Nuestro equipo de verificación iniciará el proceso de validación.",
  emailConfirmation: "Confirmación por correo electrónico",
  emailConfirmationDescription: "Recibirás un correo electrónico de confirmación en la dirección proporcionada.",
  verificationTime: "Tiempo de verificación",
  verificationTimeDescription: "El proceso de verificación suele tardar 24-48 horas laborables.",
  activationNotification: "Notificación de activación",
  activationNotificationDescription: "Una vez aprobado, recibirás las credenciales de acceso por correo electrónico.",
  whatHappensNow: "¿Qué sucede ahora?",
  whatHappensNow1: "El equipo de Confimea Imprese verificará los documentos enviados",
  whatHappensNow2: "Si es necesario, podemos contactarte para aclaraciones adicionales",
  whatHappensNow3: "Recibirás las credenciales de acceso a la plataforma Manager",
  whatHappensNow4: "Podrás comenzar a gestionar tus clientes y sus documentos",
  goToLoginPage: "IR A LA PÁGINA DE INICIO DE SESIÓN",
  associationDocumentUnavailable:
    "No se pudo cargar el documento de la asociación. Inténtalo de nuevo más tarde.",
  paymentSummary: "Resumen de la operación:",
  preferPayPal: "Si prefieres, paga con PayPal",
};

export default confimeaDictES;

